export const SELECT_PRODUCT_OPTION_GROUP = 'Menu/SELECT_PRODUCT_OPTION_GROUP';
export const SELECT_PRODUCT_OPTION = 'Menu/SELECT_PRODUCT_OPTION';
